import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Spin, Result } from "antd";
import API from "Util/Axios";
import CotizacionDocumento from "components/Cotizacion/Detalle/CotizacionDocumento";
import PrintGate from "./PrintGate";

// ---------------------------------------------------------------------------
// /print/cotizacion/:id — visited by jag-backend's Puppeteer PDF route
// (GET /cotizacion/:id/pdf) and, for manual QA, by a developer's own
// browser. No app chrome (no Navbar/Sidebar) — just the printable document,
// reusing CotizacionDocumento verbatim for guaranteed visual parity with
// the interactive Drawer.
// ---------------------------------------------------------------------------

const CotizacionPrintContent = ({ id }) => {
  const [doc, setDoc] = useState(null);
  const [empresa, setEmpresa] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    setError(null);

    Promise.all([API.get(`cotizacion/${id}`), API.get("config-site")])
      .then(([{ data: cotizacion }, { data: config }]) => {
        if (cancelled) return;
        setDoc(cotizacion);
        setEmpresa(config?.empresa || { nombre: "Empresa no configurada" });
      })
      .catch((err) => {
        if (!cancelled) setError(err);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, [id]);

  if (error) {
    return <Result status="error" title="No se pudo cargar la cotización" />;
  }

  if (loading || !doc) {
    return (
      <div style={{ width: "100%", padding: 80, textAlign: "center" }}>
        <Spin spinning tip="Cargando..." />
      </div>
    );
  }

  return <CotizacionDocumento doc={doc} empresa={empresa} />;
};

const CotizacionPrintPage = () => {
  const { id } = useParams();

  return (
    <PrintGate>
      <CotizacionPrintContent id={id} />
    </PrintGate>
  );
};

export default CotizacionPrintPage;
